import { http } from '@/lib/http';
import { ReactRenderer } from '@tiptap/react';
import tippy from 'tippy.js';
import { MentionList } from './MentionList';

const getFilteredMentions = (users, query) => {
  return users
    .filter((item) =>
      item?.name?.toLowerCase()?.startsWith(query?.toLowerCase())
    )
    .slice(0, 20);
};

const suggestion = () => ({
  items: async ({ query }) => {
    const res = await http.get(`/users/search?name=${query}`);
    const users = res?.data;
    return getFilteredMentions(users, query);
  },

  render: () => {
    let reactRenderer;
    let popup;

    return {
      onStart: (props) => {
        reactRenderer = new ReactRenderer(MentionList, {
          props,
          editor: props.editor,
        });

        popup = tippy('body', {
          getReferenceClientRect: props.clientRect,
          appendTo: () => document.body,
          content: reactRenderer?.element,
          showOnCreate: true,
          interactive: true,
          trigger: 'manual',
          placement: 'bottom-start',
        });
      },

      onUpdate(props) {
        reactRenderer?.updateProps(props);

        popup?.[0]?.setProps({
          getReferenceClientRect: props.clientRect,
        });
      },

      onKeyDown(props) {
        if (props.event.key === 'Escape') {
          popup?.[0]?.hide();

          return true;
        }

        return reactRenderer?.ref?.onKeyDown(props);
      },

      onExit() {
        popup?.[0]?.destroy();
        reactRenderer?.destroy();
      },
    };
  },
});

export default suggestion;
